// Author thq
// Date 2024-03-25 18:22:03

class TpmTsdOpcConfigTtc {
constructor({
        id = null,
        ttcEocId = '',
        ttcEocName = '',
        ttcWorkshopId = '',
        ttcDeviceId = '',
        ttcInterfaceName = '',
        ttcEntityName = '',
        ttcFieldName = '',
        ttcFieldDesc = '',
        ttcUpperLimit = '',
        ttcLowerLimit = '',
        ttcSeq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.ttcEocId = ttcEocId;
    this.ttcEocName = ttcEocName;
    this.ttcWorkshopId = ttcWorkshopId;
    this.ttcDeviceId = ttcDeviceId;
    this.ttcInterfaceName = ttcInterfaceName;
    this.ttcEntityName = ttcEntityName;
    this.ttcFieldName = ttcFieldName;
    this.ttcFieldDesc = ttcFieldDesc;
    this.ttcUpperLimit = ttcUpperLimit;
    this.ttcLowerLimit = ttcLowerLimit;
    this.ttcSeq = ttcSeq;
    this.remark = remark;
}
}

function newEntity() {
return new TpmTsdOpcConfigTtc();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcEocId',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.grid.ttcEocId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcEocName',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.grid.ttcEocName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcWorkshopId',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.grid.ttcWorkshopId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcDeviceId',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.grid.ttcDeviceId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcDeviceCode',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.grid.ttcDeviceCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcInterfaceName',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.grid.ttcInterfaceName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcEntityName',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.grid.ttcEntityName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcFieldName',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.grid.ttcFieldName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcFieldDesc',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.grid.ttcFieldDesc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcUpperLimit',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.grid.ttcUpperLimit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcLowerLimit',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.grid.ttcLowerLimit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ttcSeq',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.grid.ttcSeq',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    ttcEocIdFilter : '',
    ttcEocNameFilter : '',
    ttcWorkshopIdFilter : '',
    ttcDeviceIdFilter : '',
    ttcInterfaceNameFilter : '',
    ttcEntityNameFilter : '',
    ttcFieldNameFilter : '',
    ttcFieldDescFilter : '',
    ttcUpperLimitFilter : '',
    ttcLowerLimitFilter : '',
    ttcSeqFilter : '',
    remarkFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'ttcEocIdFilter',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.filter.ttcEocId',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcEocNameFilter',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.filter.ttcEocName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'com.siemens.mmf.em.base.opcClient.common.entity.EmOpcComputedEoc'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"ttcEocId":"id"}'
                }
        },
        {
        key: 'ttcWorkshopIdFilter',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.filter.ttcWorkshopId',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcDeviceIdFilter',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.filter.ttcDeviceId',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcInterfaceNameFilter',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.filter.ttcInterfaceName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcEntityNameFilter',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.filter.ttcEntityName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcFieldNameFilter',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.filter.ttcFieldName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcFieldDescFilter',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.filter.ttcFieldDesc',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcUpperLimitFilter',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.filter.ttcUpperLimit',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcLowerLimitFilter',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.filter.ttcLowerLimit',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcSeqFilter',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.filter.ttcSeq',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remarkFilter',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.filter.remark',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'ttcEocId',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.entity.ttcEocId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcEocName',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.entity.ttcEocName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"ttcEocId":"id"}'
                }
        },
        {
        key: 'ttcWorkshopId',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.entity.ttcWorkshopId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcDeviceId',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.entity.ttcDeviceId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'id'
            ,fieldsBindingByEntityModalSelected: '{"remark":"code"}'
                }
        },
        {
        key: 'ttcInterfaceName',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.entity.ttcInterfaceName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcEntityName',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.entity.ttcEntityName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcFieldName',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.entity.ttcFieldName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcFieldDesc',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.entity.ttcFieldDesc',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcUpperLimit',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.entity.ttcUpperLimit',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcLowerLimit',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.entity.ttcLowerLimit',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ttcSeq',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.entity.ttcSeq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.statusCollection.tpmTsdOpcConfigTtc.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {TpmTsdOpcConfigTtc, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
